/**
 * APP-SPECIFIC ADAPTER — hand-written, NOT synced. Do not add logic here.
 *
 * Binds this app's lookups endpoint to the shared Google Places core
 * (src/shared/lib/googlePlaces). patient-ui uses the bridge path
 * `/api/bridge/config/lookups`; physician-ui uses `/api/config/lookups`.
 * DO NOT unify the endpoints — the split is deliberate and pinned by
 * src/lib/addressLookups.test.ts.
 */
import { makeLookupKeyFetcher } from "../shared/lib/lookupsKey";

export * from "../shared/lib/googlePlaces";

/** Fetch (and cache) the Google Places key from the bridge. "" = disabled. */
export const getGooglePlacesKey = makeLookupKeyFetcher(
  "/api/bridge/config/lookups",
  "google_places_key",
);
